module.exports = __webpack_public_path__ + "fonts/iconfont.9c3b4c9a.woff";